export default __webpack_public_path__ + "static/media/index-based1.a0dc71bd.png";